// extracted by mini-css-extract-plugin
export default {"option":"Option_option__AMXZZ","option-image":"Option_option-image__ij9L+"};